import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, MessageCircle } from "lucide-react";
import { Mark } from "@/components/Logo";

const NAV = [
  { label: "Home", path: "/" },
  { label: "Vendita", path: "/vendita" },
  { label: "Locazione", path: "/locazione" },
  { label: "Il Gruppo", path: "/il-gruppo" },
  { label: "Contatti", path: "/contatti" },
];

export default function Footer() {
  return (
    <footer className="bg-ink text-sand" data-testid="site-footer">
      <div className="mx-auto max-w-[1440px] px-6 py-20 lg:px-12">
        <div className="grid gap-16 lg:grid-cols-12">
          <div className="lg:col-span-6">
            <div className="flex items-center gap-4">
            <img src="/logo-light.png" alt="Ideal Real Estate — L'ideale prende forma" className="h-20 w-auto" draggable="false" />
          </div>
            <p className="mt-8 max-w-md text-[15px] font-light leading-relaxed text-sand/60">
              Consulenza immobiliare, compravendite e locazioni a Milano e in tutta la Lombardia.
              IDEAL REAL ESTATE fa parte di IDEAL GROUP.
            </p>
          </div>

          <div className="lg:col-span-3">
            <p className="text-[11px] uppercase tracking-wide2 text-sand/40">Menu</p>
            <ul className="mt-6 space-y-3">
              {NAV.map((n) => (
                <li key={n.path}>
                  <Link to={n.path} className="font-serif text-xl text-sand/80 transition-colors hover:text-champagne">
                    {n.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <p className="text-[11px] uppercase tracking-wide2 text-sand/40">Contatti</p>
            <ul className="mt-6 space-y-4 text-[15px] font-light text-sand/80">
              <li className="flex items-start gap-3">
                <MapPin className="mt-0.5 h-4 w-4 text-champagne" />
                Via Soperga 16, 20127 Milano
              </li>
              <li className="flex items-start gap-3">
                <Phone className="mt-0.5 h-4 w-4 text-champagne" />
                <a href="tel:+393520042494" className="hover:text-champagne transition-colors">+39 352 004 2494</a>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="mt-0.5 h-4 w-4 text-champagne" />
                <a href="mailto:idealrealestatesrl@gmail.com" className="hover:text-champagne transition-colors">idealrealestatesrl@gmail.com</a>
              </li>
              <li className="flex items-start gap-3">
                <MessageCircle className="mt-0.5 h-4 w-4 text-champagne" />
                <a href="https://wa.me/393520042494" target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp-link" className="hover:text-champagne transition-colors">
                  WhatsApp
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-20 flex flex-col gap-3 border-t border-sand/10 pt-8 text-[12px] font-light text-sand/40 sm:flex-row sm:items-center sm:justify-between">
          <div>
            <p>© {new Date().getFullYear()} IDEAL REAL ESTATE — Parte di IDEAL GROUP. Tutti i diritti riservati.</p>
            <p className="mt-2 font-mono text-[11px] tracking-[0.12em]" data-testid="footer-vat">P.IVA 12719350964 · REA MI-2800801</p>
          </div>
          <div className="flex items-center gap-6">
            <Link to="/admin" data-testid="footer-admin-link" className="uppercase tracking-[0.2em] transition-colors hover:text-sand">
              Area riservata
            </Link>
            <p className="tracking-[0.2em] uppercase">Milano · Lombardia</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
